<template>
    <div class="items" v-if="items.messageType !== ImMessageType.NONE">
        <div class="time" v-if="items.sendTime && !systemMessageComputed">{{ items.sendTime }}</div>
        <div class="value"
            :class="{ oneself: isDoctorComputed && !systemMessageComputed, system: systemMessageComputed }">
            <div class="avatar" v-if="!systemMessageComputed">
                <van-image :src="isDoctorComputed ? doctorImage : userImage" fit="cover" />
            </div>
            <div class="content">
                <div class="name" v-if="!systemMessageComputed">
                    <span>{{ isDoctorComputed ? '医生' : '患者' }}</span>
                    <span>（{{ items.sendName }}）</span>
                </div>
                <div class="message">
                    <van-image :src="items.image" v-if="items.messageType === ImMessageType.IMAGE" fit="cover"
                        @click="onImagePreview" />
                    <div class="prescription"
                        v-else-if="items.messageType === ImMessageType.PRESCRIPTION || items.messageType === ImMessageType.CONFIRM">
                        <div class="header">
                            <div class="cell">
                                <span>诊断：</span>
                                <span>{{ prescriptionComputed.diagnose }}</span>
                            </div>
                        </div>
                        <div class="drugs" v-if="prescriptionComputed.drug">
                            <div class="cell" v-for="(item, index) in prescriptionComputed.drug" :key="index">
                                <span>{{ item.drugName }}</span>
                                <span>{{ item.quantity }}{{ item.dosageUnitName }}</span>
                            </div>
                        </div>
                        <div class="foot">
                            {{
        items.messageType === ImMessageType.PRESCRIPTION
            ? '已开方'
            : '已支付'
                            }}
                        </div>
                    </div>
                    <span v-else>{{ items.text }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { api as viewerApi } from "v-viewer"

const ImMessageType = {
    NONE: 0,
    // 文本
    TEXT: 1,
    // 图片
    IMAGE: 2,
    // 处方
    PRESCRIPTION: 3,
    // 系统消息
    SYSTEM: 4,
    // 主动结束
    TOEND: 15,
    // 处方确认(已支付)
    CONFIRM: 16,
    // 已接诊
    ASKED: 17
}
export default {
    props: {
        items: {
            type: Object,
            default: () => ({})
        },
        doctorImage: {
            type: String,
            default: ''
        },
        userImage: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            ImMessageType
        }
    },
    computed: {
        isDoctorComputed() {
            return this.items.fromAccount.includes('YS')
        },
        systemMessageComputed() {
            return this.items.messageType === ImMessageType.SYSTEM
        },
        prescriptionComputed() {
            return (this.items.messageType === ImMessageType.PRESCRIPTION ||
                this.items.messageType === ImMessageType.CONFIRM) &&
                this.items.payload
                ? JSON.parse(this.items.payload)
                : {}
        }
    },
    methods: {
        onImagePreview() {
            viewerApi({
                options: {
                    toolbar: true,
                    initialViewIndex: 0,
                    zIndex: 9999,
                    zoomRatio: 0.5,
                    title: false,
                },
                images: [this.items.image]
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/base";

.messages {
    flex: 1;
    overflow-y: auto;

    .items {
        .time {
            text-align: center;
            color: #999;
            margin-bottom: 10px;
            font-size: 15px;
        }

        .value {
            display: flex;
            padding: 0 15px 15px;
            gap: 10px;

            .avatar {
                flex: none;
                width: 50px;
                height: 50px;
                border-radius: 6px;
                overflow: hidden;
                .van-image {
                    width: 100%;
                    height: 100%;
                }
            }

            .content {
                max-width: 70%;

                .name {
                    font-size: 16px;
                    color: #666;
                }

                .message {
                    display: inline-block;
                    background: #f7f7f7;
                    padding: 15px;
                    margin-top: 10px;
                    border-radius: 6px;
                    text-align: left;

                    .van-image {
                        width: 120px;
                        height: 120px;
                    }

                    .prescription {
                        width: 280px;

                        .header {
                            .cell {
                                &:not(:first-child) {
                                    margin-top: 5px;
                                }
                            }
                        }

                        .drugs {
                            .cell {
                                @include flex(center, space-between);
                                margin-top: 5px;
                            }
                        }

                        .foot {
                            text-align: center;
                            margin-top: 15px;
                            padding-top: 10px;
                            border-top: 1px solid rgba(#000, 0.1);
                        }
                    }
                }
            }

            &.oneself {
                flex-direction: row-reverse;

                .content {
                    text-align: right;

                    .message {
                        background: #e9f3fd;
                    }
                }
            }

            &.system {
                justify-content: center;
                font-size: 15px;

                .message {
                    text-align: center;
                    background: #f7f7f7;
                    padding: 5px;
                }
            }
        }
    }
}
</style>